import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SpeakerphoneIcon, XIcon } from '@heroicons/react/outline';
export var Banner = function Banner() {
  return _jsx("div", {
    className: "bg-indigo-600",
    children: _jsx("div", {
      className: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8",
      children: _jsxs("div", {
        className: "flex items-center justify-between flex-wrap",
        children: [_jsxs("div", {
          className: "w-0 flex-1 flex items-center",
          children: [_jsx("span", {
            className: "flex p-2 rounded-lg bg-indigo-800",
            children: _jsx(SpeakerphoneIcon, {
              className: "h-6 w-6 text-white",
              "aria-hidden": "true"
            })
          }), _jsxs("p", {
            className: "ml-3 font-medium text-white truncate",
            children: [_jsx("span", {
              className: "md:hidden",
              children: "We announced a new product!"
            }), _jsx("span", {
              className: "hidden md:inline",
              children: "Big news! We're excited to announce a brand new product."
            })]
          })]
        }), _jsx("div", {
          className: "order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto",
          children: _jsx("a", {
            href: "#",
            className: "flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50",
            children: "Learn more"
          })
        }), _jsx("div", {
          className: "order-2 flex-shrink-0 sm:order-3 sm:ml-3",
          children: _jsxs("button", {
            type: "button",
            className: "-mr-1 flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2",
            children: [_jsx("span", {
              className: "sr-only",
              children: "Dismiss"
            }), _jsx(XIcon, {
              className: "h-6 w-6 text-white",
              "aria-hidden": "true"
            })]
          })
        })]
      })
    })
  });
};